import React from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'

function Home() {
  return (
    <>
    <Sidebar/>
    <main class="main-content">
        <Header/>

        <div class="content-inner container-fluid pb-0" id="page_layout">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                <div class="d-flex flex-column">
                    <h3>Dashboard</h3>
                    <p class="text-primary mb-0">Dashboard</p>
                </div>
            </div>
        </div>
    </main>
    </>
  )
}

export default Home